import nodeConfig, {
  MaybeNodeConfig,
  NodeConfig
} from '../../config/NodeConfig';

interface MaybeKernelConfig extends MaybeNodeConfig {
  binaryLocation?: string;
  runtimeLocation?: string;
  isPath?: boolean;
}

export interface KernelConfig extends NodeConfig {
  binaryLocation: string;
  runtimeLocation: string;
  isPath: boolean;
}

export default function kernelConfig(obj?: MaybeKernelConfig): KernelConfig {
  const node = nodeConfig(obj);
  const binaryLocation = (obj && obj.binaryLocation) || '';
  const runtimeLocation = (obj && obj.runtimeLocation) || '';
  const isPath = (obj && obj.isPath) || false;
  return {
    ...node,
    binaryLocation,
    runtimeLocation,
    isPath
  };
}
